
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexRBnWRDqXjfLgmKOlBh7Uf24EKgCBONZlgUVgLowP2xQMeta } from "/home/rizoa/workd/project-2025/LUME_N_CO/101RED/dashboard:client/pages/index.vue?macro=true";
import { default as labsxAp8odEPV57ETQEkWgnoBkFbp_45hD33Bu1cRhtF_W1jcMeta } from "/home/rizoa/workd/project-2025/LUME_N_CO/101RED/node_modules/.c12/gitlab_ikamai_nuxt_y3SYUSEha/pages/_labs/labs.vue?macro=true";
import { default as JsonEditorPagexywEua1JxgxGuGqlf9llytw48iqk_bqcKcUCllmWXHsMeta } from "/home/rizoa/workd/project-2025/LUME_N_CO/101RED/node_modules/.c12/gitlab_ikamai_nuxt_y3SYUSEha/pages/_labs/JsonEditorPage.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/home/rizoa/workd/project-2025/LUME_N_CO/101RED/dashboard:client/pages/index.vue")
  },
  {
    name: "_labs-labs",
    path: "/_labs/labs",
    meta: labsxAp8odEPV57ETQEkWgnoBkFbp_45hD33Bu1cRhtF_W1jcMeta || {},
    component: () => import("/home/rizoa/workd/project-2025/LUME_N_CO/101RED/node_modules/.c12/gitlab_ikamai_nuxt_y3SYUSEha/pages/_labs/labs.vue")
  },
  {
    name: "_labs-JsonEditorPage",
    path: "/_labs/JsonEditorPage",
    component: () => import("/home/rizoa/workd/project-2025/LUME_N_CO/101RED/node_modules/.c12/gitlab_ikamai_nuxt_y3SYUSEha/pages/_labs/JsonEditorPage.vue")
  }
]